import jwtDecode from "jwt-decode";
import axios from "src/utils/axios";

const refresh = () =>
  new Promise((resolve, reject) => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    delete axios.defaults.headers.common.Authorization;
    axios
      .post("/api/account/refresh", { accessToken, refreshToken })
      .then((response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          reject(false);
        }
      })
      .catch((error) => {
        reject(false);
      });
  });

class AuthService {
  setAxiosInterceptors = ({ onLogout }) => {
    axios.interceptors.response.use(
      //response => response, error => {
      undefined,
      (error) => {
        if (error.response && error.response.status === 401) {
          if (
            error.response.status === 401 &&
            error.response.headers["token-expired"] === "true"
          ) {
            var refreshResponse;
            return refresh()
              .then((res) => {
                refreshResponse = res;
                if (!refreshResponse) {
                  this.setSession(null);
                  if (onLogout) {
                    onLogout();
                  }
                }
                this.setSession(
                  res.accessToken,
                  res.refreshToken,
                  res.passphrase
                );
                error.config.headers["Authorization"] =
                  "Bearer " + res.accessToken;
                return axios.request(error.config);
              })
              .catch((err) => {
                this.setSession(null);
                if (onLogout) {
                  onLogout();
                }
              });
          } else {
            console.log("401 - Refresh Token desactualizado - Doble acceso");
            this.setSession(null);

            if (onLogout) {
              onLogout();
            }
          }
        }
        return Promise.reject(error);
      }
    );
  };

  handleAuthentication() {
    const accessToken = this.getAccessToken();
    const refreshToken = this.getRefreshToken();
    const passphrase = this.getPassphrase();

    if (!accessToken) {
      return;
    }

    this.setSession(accessToken, refreshToken, passphrase);

    // if (this.isValidToken(accessToken)) {
    //   this.setSession(accessToken,refreshToken);
    // } else {
    //   this.setSession(null);
    // }
  }

  loginWithEmailAndPassword = (email, password, cedula) =>
    new Promise((resolve, reject) => {
      axios
        .post("/api/account/login", { email, password, cedula })
        .then((response) => {
          if (response.data.user) {
            this.setSession(
              response.data.accessToken,
              response.data.refreshToken,
              response.data.user.user.passphrase
            );
            resolve(response.data.user);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  loginInWithToken = () =>
    new Promise((resolve, reject) => {
      axios
        .get("/api/account/me")
        //axios.get('https://localhost:44350/api/account/me')
        .then((response) => {
          if (response.data.user) {
            resolve(response.data.user);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          if (error) {
            resolve("");
          } else {
            reject(error);
          }
        });
    });

  logout = () => {
    this.setSession(null);
  };

  setSession = (accessToken, refreshToken, passphrase) => {
    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("passphrase", passphrase);
      delete axios.defaults.headers.common.Authorization;
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      console.log("Agregue Bearer en los Headers");
    } else {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("passphrase");
      delete axios.defaults.headers.common.Authorization;
      console.log("Borre AccessToken y Bearer de los headers");
    }
  };

  getAccessToken = () => localStorage.getItem("accessToken");
  getRefreshToken = () => localStorage.getItem("refreshToken");
  getPassphrase = () => localStorage.getItem("passphrase");

  isValidToken = (accessToken) => {
    if (!accessToken) {
      return false;
    }

    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  };

  isAuthenticated = () => !!this.getAccessToken();
}

const authService = new AuthService();

export default authService;
